import { NgModule } from '@angular/core';
import { AppButtonModule } from 'src/app/components/button/button.module';

import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

/** Layout files */
import { AppLayout } from './app.layout';

@NgModule({
  declarations: [
    AppLayout
  ],
  imports: [
    AppButtonModule,
    CommonModule,
    RouterModule
  ]
})

export class AppLayoutModule { }
